import { MessageCircle, Phone } from "lucide-react";
import { yen } from "../lib/api";
import { waLink, telLink } from "../lib/wa";
import { useStore } from "../lib/store";

const STATUS_ID = {
  new: "baru diterima",
  processing: "sedang kami siapkan",
  done: "sudah selesai",
  cancelled: "dibatalkan",
};

/** Ikon WhatsApp & telepon untuk menghubungi pembeli pesanan online. */
export const OrderContactButtons = ({ order }) => {
  const { storeName } = useStore();
  const c = order.customer || {};
  const waRaw = c.whatsapp || c.phone;
  const text = [
    `Halo ${c.name || ""}, ini ${storeName}.`,
    `Pesanan *${order.order_no}* Anda ${STATUS_ID[order.status] || order.status}.`,
    "",
    ...order.items.map((it) => `• ${it.name} x${it.qty} — ${yen(it.price * it.qty)}`),
    `Total: *${yen(order.total)}*`,
    order.fulfillment === "delivery"
      ? `Pengiriman ke: ${c.address || "-"}`
      : "Diambil di toko kami.",
    "",
    "Ada yang ingin dikonfirmasi? Balas pesan ini ya 🙏",
  ].join("\n");

  const wa = waLink(waRaw, text, c.whatsapp_cc || "81");
  const tel = telLink(c.phone || waRaw);

  if (!wa && !tel) return null;
  return (
    <div className="flex gap-2">
      {wa && (
        <a
          href={wa}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`wa-contact-${order.id}`}
          title="Chat WhatsApp pembeli"
          className="inline-flex items-center gap-1.5 text-xs font-medium rounded-full px-3 py-1.5 bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-100 transition-colors duration-200"
        >
          <MessageCircle size={14} /> WhatsApp
        </a>
      )}
      {tel && (
        <a
          href={tel}
          data-testid={`tel-contact-${order.id}`}
          title="Telepon pembeli"
          className="inline-flex items-center gap-1.5 text-xs font-medium rounded-full px-3 py-1.5 bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100 transition-colors duration-200"
        >
          <Phone size={14} /> Telepon
        </a>
      )}
    </div>
  );
};
